import React, {useEffect, useState} from 'react'
import {Link} from 'gatsby'
import styled from 'styled-components'
import Container from './container'

export default function WorkSubNav({currentPageName, limitedEditionPrintsAreAvailable}) {
  const [scrollInfo, setScrollInfo] = useState({x: {value: 0}})
  const [navRef, setNavRef] = useState(null)

  // Create a custom scroll tracking effect without external dependencies
  useEffect(() => {
    if (typeof window !== 'undefined' && navRef) {
      const handleScroll = () => {
        if (navRef) {
          setScrollInfo({x: {value: navRef.scrollLeft}})
        }
      }

      navRef.addEventListener('scroll', handleScroll)

      // Initial scroll position
      handleScroll()

      return () => {
        if (navRef) {
          navRef.removeEventListener('scroll', handleScroll)
        }
      }
    }
  }, [navRef])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const timeoutId = setTimeout(function () {
        if (scrollInfo.x.value > 0) {
          localStorage.setItem('workSubNavScrollX', scrollInfo.x.value)
          localStorage.setItem('workSubNavScrollXisZero', false)
        } else {
          localStorage.setItem('workSubNavScrollXisZero', true)
        }
      }, 50)

      return () => clearTimeout(timeoutId)
    }
  }, [scrollInfo])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const workSubNavEl = document.querySelector('nav.work-sub-nav')
      const siteMainEl = document.querySelector('main.site-main')
      if (workSubNavEl) {
        const workSubNavScrollXisZero = localStorage.getItem('workSubNavScrollXisZero')
        if (workSubNavScrollXisZero === 'true') {
          workSubNavEl.scrollLeft = 0
        } else if (siteMainEl && siteMainEl.classList.contains('site-main--work-2000-present')) {
          workSubNavEl.scrollLeft = 0
        } else {
          const workSubNavScrollX = localStorage.getItem('workSubNavScrollX')
          if (workSubNavScrollX) {
            workSubNavEl.scrollLeft = parseInt(workSubNavScrollX, 10)
          }
        }
      }
    }
  }, [])

  return (
    <StyledComponent>
      <Container>
        <nav className="work-sub-nav" ref={navRef}>
          <ul className="work-sub-nav__list">
            <li className="work-sub-nav__list-item">
              <Link
                to="/work"
                className={`work-sub-nav__link work-sub-nav__link--work-2000-present ${
                  currentPageName === 'work-2000-present' ? 'active' : ''
                }`}
              >
                2000 &ndash; Present
              </Link>
            </li>
            <li className="work-sub-nav__list-item">
              <Link
                to="/work-1980-2000"
                className={`work-sub-nav__link work-sub-nav__link--work-1980-2000 ${
                  currentPageName === 'work-1980-2000' ? 'active' : ''
                }`}
              >
                1980 &ndash; 2000
              </Link>
            </li>
            <li className="work-sub-nav__list-item">
              <Link
                to="/work-1950-1980"
                className={`work-sub-nav__link work-sub-nav__link--work-1950-1980 ${
                  currentPageName === 'work-1950-1980' ? 'active' : ''
                }`}
              >
                1950 &ndash; 1980
              </Link>
            </li>
            <li className="work-sub-nav__list-item">
              <Link
                to="/ra-solo-show"
                className={`work-sub-nav__link work-sub-nav__link--ra-solo-show ${
                  currentPageName === 'ra-solo-show' ? 'active' : ''
                }`}
              >
                RA Solo Show
              </Link>
            </li>
            <li className="work-sub-nav__list-item">
              <Link
                to="/public-collections"
                className={`work-sub-nav__link work-sub-nav__link--public-collections ${
                  currentPageName === 'public-collections' ? 'active' : ''
                }`}
              >
                Public Collections
              </Link>
            </li>
            <li className="work-sub-nav__list-item">
              <Link
                to="/watercolours"
                className={`work-sub-nav__link work-sub-nav__link--watercolours ${
                  currentPageName === 'watercolours' ? 'active' : ''
                }`}
              >
                Watercolours
              </Link>
            </li>
            <li className="work-sub-nav__list-item">
              <Link
                to="/sketchbooks"
                className={`work-sub-nav__link work-sub-nav__link--sketchbooks ${
                  currentPageName === 'sketchbooks' ? 'active' : ''
                }`}
              >
                Sketchbooks
              </Link>
            </li>
          </ul>
        </nav>
      </Container>
    </StyledComponent>
  )
}

const StyledComponent = styled.div`
  background-color: #fff;
  padding: 0;
  width: 100%;
  z-index: 10;

  @media (min-width: 1200px) {
    padding: 3rem 0 2rem 0;
    position: sticky;
    top: 113px;
  }

  > div.container {
    position: relative;

    &::after {
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
      content: '';
      display: block;
      height: 100%;
      pointer-events: none;
      position: absolute;
      right: 2rem;
      top: 0;
      width: 8rem;

      @media (min-width: 1200px) {
        display: none;
      }
    }
  }

  .work-sub-nav {
    overflow-x: auto;
    padding-bottom: 2rem;
  }

  ul {
    display: flex;
    flex-direction: row;
    list-style: none;
    margin: 0;
    padding: 0 6rem 0 0;
    justify-content: space-between;

    @media (max-width: 1200px) {
      min-width: 123rem;
    }

    @media (min-width: 1200px) {
      padding-right: 0;
    }
  }
  li {
  }
  a {
    display: block;
    font-size: 1.5rem;
    font-weight: 100;
    height: 100%;
    text-align: center;
    position: relative;

    &::after {
      background-color: #909090;
      bottom: 0;
      content: '';
      display: block;
      height: 1px;
      left: 0;
      position: absolute;
      transform: scaleX(0);
      transform-origin: top left;
      transition: all 0.25s linear;
      width: 100%;
    }

    &:not(.active) {
      &:hover {
        &::after {
          transform: scaleX(1);
        }
      }
    }

    span.secondary {
      color: #646464;
      font-size: 1.3rem;
    }
  }
`
